import { StatusGraphNode } from '@models';
import { createAction, props } from '@ngrx/store';

export enum StatusGraphActionTypes {
  Fetch = '[Status Graph] Fetch',
  FetchFail = '[Status Graph] Fetch Fail',
  FetchSuccess = '[Status Graph] Fetch Success',

  Save = '[Status Graph] Save',
  SaveFail = '[Status Graph] Save Fail',
  SaveSuccess = '[Status Graph] Save Success',
}

export const fetchStatusGraph = createAction(StatusGraphActionTypes.Fetch);

export const fetchStatusGraphSuccess = createAction(
  StatusGraphActionTypes.FetchSuccess,
  props<{ statusGraph: StatusGraphNode[] }>(),
);

export const fetchStatusGraphFail = createAction(StatusGraphActionTypes.FetchFail);

export const saveStatusGraph = createAction(StatusGraphActionTypes.Save, props<{ statusGraph: StatusGraphNode[] }>());
export const saveStatusGraphFail = createAction(StatusGraphActionTypes.SaveFail);
export const saveStatusGraphSuccess = createAction(StatusGraphActionTypes.SaveSuccess);
